import { useSelector } from '../dependencies';

import { activeCompanyIdSelector } from '../services/selectors';

export function useActiveCompanyId() {
    return useSelector(activeCompanyIdSelector);
}
